(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kas-general-display-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.kas-product');
    sections.forEach((section) => {
      if (section.dataset.kasReady === 'true') return;
      section.dataset.kasReady = 'true';
      const variants = JSON.parse(section.querySelector('[data-kas-variants]').textContent);
      const variantInput = section.querySelector('[data-variant-input]');
      const sku = section.querySelector('[data-product-sku]');
      const stock = section.querySelector('[data-product-stock]');
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const addButton = section.querySelector('[data-add-button]');
      const addLabel = section.querySelector('[data-add-label]');
      const saving = section.querySelector('[data-box-saving]');
      const quantity = section.querySelector('input[name="quantity"]');
      const firstVariant = variants[0];
      const parsePack = (title) => {
        if (!/box|pack|case/i.test(title)) return 1;
        const match = title.match(/\d+/);
        return match ? Number(match[0]) : 1;
      };
      const money = (cents) => {
        const sample = firstVariant.price_text;
        const value = (cents / 100).toFixed(2);
        if (sample.includes('£')) return `£${value}`;
        if (sample.includes('$')) return `$${value}`;
        if (sample.includes('€')) return `€${value}`;
        return value;
      };
      const updateUnits = () => {
        variants.forEach((variant) => {
          const pack = parsePack(variant.title);
          const target = section.querySelector(`[data-variant-unit="${variant.id}"]`);
          if (target && pack > 1) target.textContent = `${money(Math.round(variant.price / pack))} each`;
        });
      };
      const updateMedia = (mediaId) => {
        if (!mediaId) return;
        section.querySelectorAll('[data-media-id]').forEach((item) => item.classList.toggle('is-active', item.dataset.mediaId === String(mediaId)));
        section.querySelectorAll('[data-media-target]').forEach((item) => item.classList.toggle('is-active', item.dataset.mediaTarget === String(mediaId)));
      };
      const update = (variant) => {
        variantInput.value = variant.id;
        sku.textContent = variant.sku || variant.id;
        price.textContent = variant.price_text;
        if (variant.compare_price > variant.price) {
          compare.textContent = variant.compare_text;
          compare.classList.remove('is-hidden');
        } else compare.classList.add('is-hidden');
        const pack = parsePack(variant.title);
        const unitName = pack > 1 ? `boxes of ${pack}` : 'individual items';
        if (!variant.available) stock.textContent = 'Out of stock';
        else if (variant.inventory_management && variant.inventory_quantity > 0) stock.textContent = `Availability: ${variant.inventory_quantity.toLocaleString()} ${unitName} in stock`;
        else if (variant.inventory_policy === 'continue') stock.textContent = 'Available to order';
        else stock.textContent = 'In stock';
        addButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? addButton.closest('.kas-product').dataset.addLabel || 'Add to basket' : 'Sold out';
        section.querySelectorAll('.kas-product__variant-card').forEach((card) => card.classList.toggle('is-selected', card.querySelector('input').checked));
        const base = variants.find((item) => parsePack(item.title) === 1);
        if (saving && base && pack > 1) {
          const fullPrice = base.price * pack;
          const saved = fullPrice - variant.price;
          if (saved > 0) {
            saving.textContent = `Box saving: ${money(saved)} compared with buying ${pack} individually. This box also qualifies for Spend & Save.`;
            saving.classList.remove('is-hidden');
          } else saving.classList.add('is-hidden');
        } else if (saving) saving.classList.add('is-hidden');
        updateMedia(variant.media_id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };
      section.dataset.addLabel = addLabel.textContent.trim();
      section.querySelectorAll('input[name^="kas-variant-"]').forEach((radio) => radio.addEventListener('change', () => update(variants.find((variant) => String(variant.id) === radio.value))));
      section.querySelectorAll('[data-media-target]').forEach((thumb) => thumb.addEventListener('click', () => updateMedia(thumb.dataset.mediaTarget)));
      section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
      section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) + 1); });
      updateUnits();
      update(variants.find((variant) => String(variant.id) === variantInput.value) || firstVariant);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kas-slatwall-finishes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-finish-dialog]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.finishDialog);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-close-dialog]');
    if (closeButton) closeButton.closest('dialog')?.close();

    if (event.target instanceof HTMLDialogElement) {
      const bounds = event.target.getBoundingClientRect();
      const withinDialog = event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
      if (!withinDialog) event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kas-terms-conditions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-kas-print]')) window.print();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
